/**
 * "Payment date" cell for the redemptions table: when Xero recorded the
 * merchant's bill as paid (Redemption.invoicePaidAt, Xero FullyPaidOnDate).
 */

// Xero paid dates are calendar dates stored at UTC midnight; format in UTC so
// the day does not shift with the viewer's timezone.
export function formatRedemptionPaymentDate(redemption) {
  if (!redemption) return "Not paid yet";
  if (redemption.invoicePaidAt) {
    const date = new Date(redemption.invoicePaidAt);
    if (!Number.isNaN(date.getTime())) {
      return date.toLocaleDateString(undefined, { timeZone: "UTC" });
    }
  }
  if (redemption.active === false) return "-";
  const status = String(redemption.invoiceStatus || "").toUpperCase();
  if (status === "VOIDED" || status === "DELETED") return "-";
  // Paid before paid dates were recorded and not yet backfilled.
  if (status === "PAID") return "Paid";
  return "Not paid yet";
}
